export default "__VITE_ASSET__CNL0TIzE__"